import React, {Suspense, useContext} from "react";
import OfferContext from "../../store/OfferContext";

const ThemeSimbud = React.lazy( () => import('../../styles/ThemeSimbud'))
const ThemeActualite = React.lazy( () => import('../../styles/ThemeActualite'))
const ThemeProtegezVous = React.lazy( () => import('../../styles/ThemeProtegezVous'))

const LazyThemeCss = ({children}) => {
    const offerCtx = useContext(OfferContext)

    let shouldRenderActualite = false
    let shouldRenderProtegezVous = false
    let shouldRenderSimbud = false

    switch (offerCtx.theme) {
        case 'actualite':
            shouldRenderActualite = true;
            break;
        case 'protegezvous':
            shouldRenderProtegezVous = true;
            break;
        case 'simbud':
            shouldRenderSimbud = true;
            break;
        default:
            shouldRenderSimbud = true;
            break;
    }
    
    return(
            <>
                <Suspense fallback={ null }>
                    { shouldRenderActualite && <ThemeActualite key='actualite' /> }
                    { shouldRenderProtegezVous && <ThemeProtegezVous key='protegezvous' /> }
                    { shouldRenderSimbud && <ThemeSimbud key='simbud' /> }
                </Suspense>
                { children }
            </>

    )
}

export default LazyThemeCss;
